<!-- Copyright (c) 2024 VMware, Inc. All rights reserved. -- VMware Confidential -->
<clr-toggle-container>
    <clr-toggle-wrapper>
        <input type="checkbox" clrToggle
               value="setting"
               name="options"
               [(ngModel)]="settingValue"
               (change)="settingChanged()"/>
        <label>{{label | vtranslate}}</label>
    </clr-toggle-wrapper>
</clr-toggle-container>
